import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileRenameMutationAtom = createMutationAtomFactory(
  'files.rename',
  ({ fileId, newName }: { fileId: string; newName: string }) => ({
    filesRenameFile: {
      __args: {
        fileID: fileId,
        newName,
      },
      id: true,
      fileName: true,
    },
  }),
);
